import { Outlet } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from "react";

import SkylineSmall from "../components/map/SkylineSmall";
import SkylineLarge from "../components/map/SkylineLarge";


import "../styles/screens/Background.scss";

export default function Background() {
    const location = useLocation();
    const currentRoute = location.pathname;    

    const [isRootPath, setIsRootPath] = useState();

    useEffect(() => {
        if (currentRoute === "/") {
            setIsRootPath(true);
        } else {
            setIsRootPath(false);
        }
    }, [currentRoute])


    return (
        <section className={`Background is-root-path-${isRootPath}`}>
            <SkylineLarge />
            <SkylineSmall />

            <div className="rendered-content">
                <Outlet />  
            </div>            
        </section>
    )
}